import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout';
import ContentHeader from '../layout/ContentHeader'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import SelectCustomer from '../layout/SelectCustomer';
import Helper from '../../../helper/Helper';
import httpClient from '../../../http/HttpRequest';
import Alert from '../../../feature/Alert';
import { QUOTE_DETAILS, UPDATE_QUOTE } from '../../../data/url';
import ProductCal from '../layout/ProductCal';

export default function EditQuote() {
  const { id } = useParams();
  const [customerId, setCustomerId] = useState('');
  const [state_id, setStateId] = useState('');
  const [customerDetails, setCustomerDetails] = useState({});
  const [errors, setErrors] = useState({});
  const [quoteOrder, setQuoteOrder] = useState({});
  const [customer, setCustomer] = useState({});
  const [products, setProducts] = useState([]);
  const [updatedProducts, setUpdatedProducts] = useState([]);
  const [notes, setNotes] = useState({});
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [quoteDetails, setQuoteDetails] = useState({ prefix: '', number: '', date: Helper.getToday(), due_date: '' });

  useEffect(() => {
    getOrderDetails();
  }, [])

  useEffect(() => {
    setNotes({ terms_conditions: quoteOrder.terms_conditions, private_notes: quoteOrder.private_notes });
    setQuoteDetails({ prefix: quoteOrder.prefix, number: quoteOrder.number, date: quoteOrder.date, due_date: quoteOrder.due_date !== null ? quoteOrder.due_date : '' })
  }, [customerDetails, quoteOrder]);

  useEffect(() => {
    if (products.length > 0) {
      const data = [];
      products.map((row, index) => {
        data.push(
          {
            selectedProduct: { label: row.product_name, value: row.product_id },
            desc: row.description,
            sac: row.sac,
            selectedUnit: { label: row.unit_name, value: row.unit_id },
            quantity: row.quantity,
            price: row.price,
            discount: row.discount,
            discountType: row.discountType,
            tax: row.tax,
            total: row.net_amount,
            stock: row.stock,
            taxableAmount: row.taxable_amount,
            discountAmount: row.discount_amount,
            taxAmount: row.tax_amount
          }
        )
      })
      setUpdatedProducts(data);
    }

  }, [products]);

  const getOrderDetails = async (e) => {
    const res = await httpClient.post(QUOTE_DETAILS, { quote_id: id });
    if (res.requestStatus == "OK") {
      const result = res.result;
      if (result.status == 1) {
        setCustomerId(result.data.quote_details.customer_id);
        setQuoteOrder(result.data.quote_details);
        setProducts(result.data.details);
        setCustomerDetails(result.data.customer);
      }
    }
  }

  const handelSubmit = (products, commanData, totals, txnType) => {
    if (validateField()) {
      if (products.length > 0) {
        let p = quoteDetails;
        p['customer_id'] = customerId;
        p['state'] = state_id;
        p['products'] = products;
        p['totals'] = totals;
        p['commonData'] = commanData;
        p['txnType'] = txnType;
        p['quote_id'] = id;
        saveOrder(p);
      } else {
        Alert.error('Products are empty');
      }

    }
  }

  const saveOrder = async (post) => {
    const res = await httpClient.post(UPDATE_QUOTE, post);
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        Alert.success(result.message);
        navigate('/root/quotes');
      } else {
        Alert.failure(result.message);
      }
    }
  }

  const validateField = () => {
    let formErrors = {};
    let valid = true;
    if (customerId === '') {
      Alert.error('Select Customer');
      valid = false;
    }
    setErrors(formErrors);
    return valid;
  }

  const handleInputChange = (fieldName, event) => {
    const value = event.target.value;
    const order = { ...quoteDetails };
    order[fieldName] = value;
    setQuoteDetails(order);
  };

  const remitCustomer = (data) => {
    setCustomerId(data.customer_id);
    setStateId(data.state_id);
    setCustomer(data.customer);
  }
  return (
    <AdminLayout>
      <div className="content-wrapper">
        <ContentHeader
          title="edit_quote" subTitle="quotes" subTitleLink="root/quotes"
        />
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div>
                <SelectCustomer remitCustomer={remitCustomer} customerId={customerId} />
              </div>
              <div className='row mt-2'>
                <div className='col-md-4 '>
                  <label>{t('number')}</label>
                  <div className='input-group'>
                    <div className="input-group-prepend mr-1" style={{ width: "80px" }}>
                      <input id='prefix' value={quoteDetails.prefix || ''} type='text' name='prefix' className='form-control form-control-sm' onChange={(e) => handleInputChange('prefix', e)} />
                    </div>
                    <input id='number' value={quoteDetails.number || ''} type='text' name='number' className='form-control form-control-sm' onChange={(e) => handleInputChange('number', e)} />
                  </div>
                </div>
                <div className='col-md-3'>
                  <label>{t('date')}</label>
                  <input id='date' value={quoteDetails.date} type='date' name='date' className='form-control form-control-sm' onChange={(e) => handleInputChange('date', e)} />
                </div>
                <div className='col-md-3'>
                  <label>{t('due_date')}</label>
                  <input id='due_date' value={quoteDetails.due_date} type='date' name='due_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('due_date', e)} />
                </div>
              </div>
              <ProductCal title="quote" onSubmit={handelSubmit} customer={customer} products={updatedProducts} notes={notes} />
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  )
}
